import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { injectIntl } from "react-intl";
import { Loading } from "@ebsco-ui/ebsco-ui";
import GenericError from "../generic-error";
import {
  fetchPersonalUser,
  getUserInfo,
  getUserInfoError,
  getUserInfoLoading,
  getIsSso
} from "../../store/personal-user";

import sharedMessages from "../../../shared-messages";

function withPersonalization(WrappedComponent) {
  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }

  return class extends Component {
    static displayName = `withPersonalization(${getDisplayName(
      WrappedComponent
    )})`;

    render() {
      const {
        error,
        intl: { formatMessage },
        loading,
        ...passThroughProps
      } = this.props;

      if (error) return <GenericError />;

      if (loading)
        return (
          <Loading loadingMessage={formatMessage(sharedMessages.loading)} />
        );

      return <WrappedComponent {...passThroughProps} />;
    }
  };
}

const mapStateToProps = state => ({
  error: getUserInfoError(state),
  loading: getUserInfoLoading(state),
  userInfo: getUserInfo(state),
  isSso: getIsSso(state)
});

const mapDispatchToProps = { fetchPersonalUser };

export { withPersonalization };
export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
  withPersonalization
);
